(function () {
  var sliders = document.querySelectorAll('[data-baf-slider]');

  sliders.forEach(function (slider) {
    var afterSide = slider.querySelector('[data-baf-after]');
    var handle = slider.querySelector('[data-baf-handle]');
    var dragging = false;

    function setPosition(percent) {
      percent = Math.max(0, Math.min(100, percent));
      afterSide.style.clipPath = 'inset(0 0 0 ' + percent + '%)';
      handle.style.left = percent + '%';
    }

    function positionFromEvent(clientX) {
      var rect = slider.getBoundingClientRect();
      var percent = ((clientX - rect.left) / rect.width) * 100;
      setPosition(percent);
    }

    function onPointerDown(e) {
      dragging = true;
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      positionFromEvent(clientX);
    }

    function onPointerMove(e) {
      if (!dragging) return;
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      positionFromEvent(clientX);
    }

    function onPointerUp() {
      dragging = false;
    }

    slider.addEventListener('mousedown', onPointerDown);
    slider.addEventListener('touchstart', onPointerDown, { passive: true });

    window.addEventListener('mousemove', onPointerMove);
    window.addEventListener('touchmove', onPointerMove, { passive: true });

    window.addEventListener('mouseup', onPointerUp);
    window.addEventListener('touchend', onPointerUp);

    /* Keyboard accessibility: focus the handle and use arrow keys */
    handle.setAttribute('tabindex', '0');
    handle.setAttribute('role', 'slider');
    handle.setAttribute('aria-valuemin', '0');
    handle.setAttribute('aria-valuemax', '100');
    handle.setAttribute('aria-valuenow', '50');

    handle.addEventListener('keydown', function (e) {
      var rect = slider.getBoundingClientRect();
      var currentLeft = parseFloat(handle.style.left) || 50;
      var step = 4;
      if (e.key === 'ArrowLeft') {
        setPosition(currentLeft - step);
        handle.setAttribute('aria-valuenow', Math.round(currentLeft - step));
        e.preventDefault();
      } else if (e.key === 'ArrowRight') {
        setPosition(currentLeft + step);
        handle.setAttribute('aria-valuenow', Math.round(currentLeft + step));
        e.preventDefault();
      }
    });

    /* Start centered */
    setPosition(50);
  });
})();